import React from "react";
const Spinner = () => {
  return <div className="w-8 h-8 border-4 border-gray-300 border-t-gray-900 rounded-full animate-spin"></div>
  ;
};

export default Spinner;
